import { Component, inject, OnInit, computed } from '@angular/core';
import { RegistryService } from '../../services/RegistryService';
import { AuthService } from '../../services/AuthService';
import { Card } from 'primeng/card';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [Card, TranslocoModule, RouterLink],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  public registry = inject(RegistryService);
  public auth = inject(AuthService);

  public showShiftManager = computed(() => this.registry.services().some(s => s.name === 'lite_schedule'));
  public showStaffManager = computed(() => true);
  public showTaskManager = computed(() => this.registry.services().some(s => s.name === 'tasks'));
}
